import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/public/Home";
import About from "./pages/public/About";
import PrivacyPolicy from "./pages/public/PrivacyPolicy";
import UserRequest from "./pages/public/UserRequest";
import AdminLogin from "./admin-frontend/pages/AdminLogin";
import AdminDashboard from "./admin-frontend/pages/AdminDashboard";
import UserManagement from "./admin-frontend/pages/UserManagement";
import AuditLogs from "./admin-frontend/pages/AuditLogs";
import Analytics from "./admin-frontend/pages/Analytics";
import PartnerManagement from "./admin-frontend/pages/PartnerManagement";
import ProtectedRoute from "./components/ProtectedRoute";
import Terms from "./pages/public/Terms";
import BecomePartner from "./pages/public/BecomePartner";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/user-request" element={<UserRequest />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/become-partner" element={<BecomePartner />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/audit-logs"
          element={
            <ProtectedRoute>
              <AuditLogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/analytics"
          element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/partners"
          element={
            <ProtectedRoute>
              <PartnerManagement />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
